import React from 'react';

const Column = ({ children, ...props }) => (
  <div className='column' {...props}>
    {children}
  </div>
);

export default Column;
